<template>
  <div class="banner">
    <div class="choseBox" v-show="!experimentStatus">
      <img src="../assets/img/experiment/title.png" alt="" class="title" style="position: absolute; left: 20vw; top: 10vh; width: 62vw" />
      <div class="aswerBox">
        <img
          :src="experimentData[0] == 0 ? require('../assets/img/askBox/experiment01.png') : require('../assets/img/askBox/experiment01-1.png')"
          alt=""
          @click="choseExperiment(0)"
          class="activeExperiment activeExperiment01"
        />
        <img
          :src="experimentData[1] == 0 ? require('../assets/img/askBox/experiment02.png') : require('../assets/img/askBox/experiment02-1.png')"
          alt=""
          @click="choseExperiment(1)"
          class="activeExperiment activeExperiment02"
        />
      </div>
      <img :src="homeBtnImg" @mouseenter="homeBtnActive" @mouseleave="homeBtn" class="homeBtn" @click="homeBack" />
    </div>
    <audio ref="audioPlay" :loop="false">
      <source :src="oneAudio" type="audio/mpeg" />
    </audio>
    <audio ref="audioPlayTwo" :loop="false">
      <source :src="twoAudio" type="audio/mpeg" />
    </audio>
    <audio ref="audioPlayThree" :loop="false">
      <source :src="threeAudio" type="audio/mpeg" />
    </audio>
    <audio ref="audioPlayFour" :loop="false">
      <source :src="fourAudio" type="audio/mpeg" />
    </audio>
    <experimentInteraction v-if="experimentStatus" :experimentIndex="experimentIndex" @callMethod="handleChildEvent"></experimentInteraction>
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import experimentInteraction from "./experimentInteraction.vue";
import router from "@/router";
import { ElMessage } from "element-plus";
import anime from "animejs";

import sumbitBtnImg from "../assets/img/forecast/submitBtn.png";
import sumbitBtnActiveImg from "../assets/img/forecast/submitBtnActive.png";

import home from "../assets/img/home.png";
import homeActive from "../assets/img/homeActive.png";

import twoAudio from "../assets/audio/experiment/twoAudio.mp3";
import threeAudio from "../assets/audio/experiment/threeAudio.mp3";
import fourAudio from "../assets/audio/experiment/fourAudio.mp3";

let audioPlay = ref();
let audioPlayTwo = ref();
let audioPlayThree = ref();
let audioPlayFour = ref();

// 高亮切换
let homeBtnImg = ref(home);
// 首页按钮切换
const homeBtnActive = () => {
  homeBtnImg.value = homeActive;
};
const homeBtn = () => {
  homeBtnImg.value = home;
};

// 高亮切换
let sumbitImg = ref(sumbitBtnImg);
// 首页按钮切换
const submitBtnActive = () => {
  sumbitImg.value = sumbitBtnActiveImg;
};
const submitBtn = () => {
  sumbitImg.value = sumbitBtnImg;
};

// 固定项
// 当前实验状态 false未处于实验状态
let experimentStatus = ref(false);
// 关闭回答页面
let askStatus = ref(true);
// 弹出表格页面
let tableShow = ref(false);
// 当前选择注意事项数组
let choseArray = ref([false, false, false]);

// 当前实验项目
let experimentIndex = ref(0);
// 当前实验数据
let experimentData = ref([0, 0]);

// 注意事项选择
const choseAsk = (index) => {
  choseArray.value[index] = !choseArray.value[index];
};

const choseExperiment = (id) => {
  audioPlayThree.value.pause();
  if (experimentData.value[id] != 0) {
    return;
  }
  experimentIndex.value = id;
  experimentStatus.value = true;
};

const handleChildEvent = (data, Number) => {
  experimentStatus.value = data;
  if (Number != null) {
    experimentData.value[experimentIndex.value] = Number;
    tableShow.value = true;
  }
  if (experimentData.value[0] != 0 && experimentData.value[1] != 0) {
    localStorage.setItem("soilValue", experimentData.value);
    router.push({ name: "comparePage" });
  }
};

// 切换表格显示
const sumbitBtn = () => {
  tableShow.value = false;
};

const homeBack = () => {
  router.push({ name: "home" });
};
onMounted(async () => {
  await audioPlayThree.value.play();
});
</script>
<style scoped lang="scss">
.banner {
  margin: 0px;
  padding: 0px;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  .askBox {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-size: 100% 100%;
    background-image: url(../assets/img/askBox/askBackground.png);
    z-index: 9;
    .choseBtn01 {
      top: 35vh;
      left: 25vw;
      width: 49.02vw;
      height: 12.6vh;
      background-image: url(../assets/img/askBox/choseBtn01.png);
      background-size: 100% 100%;
      position: absolute;
    }
    .choseBtn02 {
      top: 52vh;
      left: 25vw;
      width: 49.02vw;
      height: 12.6vh;
      background-image: url(../assets/img/askBox/choseBtn02.png);
      background-size: 100% 100%;
      position: absolute;
    }
    .choseBtn03 {
      top: 70vh;
      left: 25vw;
      width: 49.02vw;
      height: 12.6vh;
      background-image: url(../assets/img/askBox/choseBtn03.png);
      background-size: 100% 100%;
      position: absolute;
    }
    .activeChose::before {
      content: "";
      display: block;
      position: absolute;
      top: -5vh;
      right: -2vw;
      width: 9vw;
      height: 15vh;
      background-size: 100%;
      background-image: url(../assets/img/experiment/tick.png);
    }
    .submitBtn {
      position: absolute;
      bottom: 6vh;
      right: 45vw;
      width: 11vw;
    }
  }
  .choseBox {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url(../assets/img/double/background.png);
    background-size: 100% 100%;
    .askTitle {
      width: 100%;
      position: absolute;
      top: 50px;
      text-align: center;
      font-size: 32px;
    }
    .aswerBox {
      width: 50vw;
      display: flex;
      justify-content: space-between;
      position: absolute;
      top: 36vh;
      left: 27.5vw;
      background-image: url(../assets/img/experiment/aswerBoxBackground.png);
      background-size: 100% 100%;
      padding: 3vh 4vw;
      box-sizing: border-box;
      transform: scale(1) translateY(0);
      transition: transform 2s ease-in-out; /* 平滑过渡效果 */
      img {
        width: 18vw;
      }
      .activeExperiment:hover {
        transform: scale(1.05) translateY(-4vh);
      }
    }
  }
  .homeBtn {
    position: absolute;
    bottom: 3vh;
    right: 3vw;
    width: 4vw;
  }
  .bannerList {
    position: relative;
    width: 100vw;
    height: 100vh;
    background-size: 100% 100%;
    background-image: url(../assets/img/double/background.png);
    overflow: hidden;
    .title {
      width: 100%;
      position: absolute;
      top: 5vh;
      font-size: 2.7vw;
      color: #fff;
      text-align: center;
    }
    .compareBox {
      width: 80vw;
      position: absolute;
      top: 24vh;
      left: 10vw;
      display: flex;
      justify-content: space-between;
      .soilBox {
        position: relative;
        width: 21vw;
        height: 60vh;
        background-size: 100% 100%;
      }
      .soilOne {
        background-image: url(../assets/img/component/soil01.png);
      }
      .soilTwo {
        background-image: url(../assets/img/component/soil02.png);
      }
      .soilThree {
        background-image: url(../assets/img/component/soil03.png);
      }
      .soilValue {
        font-size: 2.4vw;
        color: #fff;
        width: 10.6vw;
        text-align: center;
        margin-top: 8.5vh;
        margin-left: 1vw;
      }
      .weightValue {
        font-size: 2.4vw;
        color: #fff;
        width: 10.6vw;
        text-align: center;
        margin-top: 37vh;
        margin-left: 1vw;
      }
    }
    .reasonBox {
      width: 46vw;
      height: 64vh;
      background-image: url(http://localhost:8080/img/reasonBox.62eb1dd7.png);
      background-size: 100% 100%;
      position: absolute;
      top: 18vh;
      right: -41vw;
    }
    .nextBtn {
      position: absolute;
      bottom: 4vh;
      right: 42vw;
      width: 16vw;
      box-sizing: border-box;
      text-align: center;
    }
    .homeBtn {
      position: absolute;
      bottom: 2vh;
      right: 2vw;
      width: 4vw;
    }
  }
}
</style>
